<template>
  <div  @click.stop="hidePop">
    <div class="popups" :style="{top: obj.top,right:obj.right}">
      <div class="popups-top" :style="{right:obj.topRight}"></div>
      <div class="popups-content">{{obj.remark}}</div>
    </div>
    <div class="mask"></div>
  </div>
</template>
<script>
export default {
  props: {
    // 传进来的样式值
    obj: {
      type: Object,
      default: {
        title: '',
        ind_unit: '元',
        remark: '',
        top: '0',
        right: '0',
        topRight: '0.15rem',
        visable: false,
        type: '',
      },
    }
  },
  methods:{
    hidePop(){
      this.$emit('hide',this.obj.type)
    }
  }
}

</script>
<style lang="less" scoped>
.font-family-fn(@family) {
  font-family: @family;
}

.popups {
  position: absolute;
  z-index: 999999999;
  border-radius: 8px;
  padding: 10px;
  background: #fff;
  right: -0.2rem;
  top: .7rem;
  width: 3rem;
  text-align: center;
  font-weight: normal;
}

.popups-content {
  color: #666;
  font-size: 0.3rem;
}

.popups-top {
  display: inline-block;
  width: 0;
  height: 0;
  border: solid transparent;
  border-width: 10px;
  border-bottom-color: #fff;
  content: "";
  position: absolute;
  top: -0.35rem;
  right: .2rem;
  z-index: 999999999;
}

.mask {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  opacity: 0.5;
  background: #000;
  z-index: 99999999;
}

</style>



// WEBPACK FOOTER //
// src/components/app/common/popup.vue